<template>
	<div>
		<div v-loading.fullscreen.lock="loading" element-loading-text="加载中,请稍候"
			element-loading-spinner="Loading">
			<div style="padding: 2% 4%;background-color: #fff;">
				<el-input style="width: 40%;" v-model="address" type="textarea" :rows="4"
					placeholder="请输入收件地址，至少精确到乡级行政区，例如:海南省海口市美兰区国兴大道9号" resize="none"></el-input>
				<el-button @click="query(address)" type="primary" icon="Search" style="margin-left: 4%;">查询</el-button>
			</div>
			<div style="margin-top: 2vh;min-height: 73vh;background-color: #fff;">
				<el-table :data="dataList" :row-class-name="rowStatusClass">
					<el-table-column prop="name" label="快递公司" width="280">
						<template #default="scope">
							<div style="display: flex;align-items: center;">
								<el-image style="width: 2em;height: 2em;border-radius: 50%;margin-right: 1em;"
									:src="global.expressLogoUrl+scope.row.code+'.png'" fit="scale-down"></el-image>
								<span>{{scope.row.name}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="statusText" label="可达情况" width="180">
						<template #default="scope">
							<span :style="{'color': scope.row.status ? '#67C23A':'#ff7c7c'}">
								{{scope.row.statusText}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="describe" label="不可达原因">
						<template #default="scope">
							<span :style="{'color': scope.row.status ? '#343434':'#ff7c7c'}">
								{{scope.row.describe}}
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				address: "",
				dataList: []
			}
		},
		methods: {
			rowStatusClass() {
				return 'success-row';
			},
			query(address) {
				
				this.loading = true;
				this.apiService.post({
						modules: "stop",
						content: {
							cpCode: ['ZTO', 'YTO', 'STO', 'YD', 'JT', 'SF', 'JDL', 'POST'],
							text: address
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.dataList = res.data.list;
						}
					})
					.finally(() => {
						this.loading = false;
					})
			}
		}
	}
</script>

<style scoped>
	/deep/ .warning-row {
		background: oldlace !important;
	}

	/deep/ .success-row {
		background: #fff !important;
	}
</style>